import { makeAutoObservable } from 'mobx'

export class StepsStore {
  private _step = 1
  private _totalSteps = 1
  private _stepLoading = false

  constructor() {
    makeAutoObservable(this)
  }

  get stepLoading() {
    return this._stepLoading
  }

  get step() {
    return this._step
  }

  get totalSteps() {
    return this._totalSteps
  }

  setStepLoading = (loading: boolean) => {
    this._stepLoading = loading
  }

  setStep = (step: number) => {
    this._step = step
  }

  setTotalSteps = (totalSteps: number) => {
    this._totalSteps = totalSteps
  }
}
